import { RadioOption } from "./components";
import { EmailActionType, TimeZoneType } from "./types";

// All 18 filter types from requirements
export const CONDITION_FIELD_OPTIONS = [
  { id: "contacts", name: "Contacts" },
  { id: "leadership", name: "Leadership" },
  { id: "invite-guests", name: "Invite Guests" },
  { id: "last-name", name: "Last Name" },
  { id: "firm-company", name: "Firm/Company" },
  { id: "jurisdiction", name: "Jurisdiction" },
  { id: "service", name: "Service" },
  { id: "assoc", name: "Assoc." },
  { id: "all-groups-practice-industry", name: "All Groups for Practice Industry" },
  { id: "private-group", name: "Private Group" },
  { id: "from-meeting-event", name: "From Meeting/Event" },
  { id: "practice-industry-specialty-group", name: "Practice/Industry/Specialty Group" },
  { id: "practice-industry", name: "Practice Industry" },
  { id: "speaker-for-meeting", name: "Speaker for meeting" },
  { id: "special-event", name: "Special Event" },
  { id: "region", name: "Region" },
  { id: "mail-address", name: "Mail Address" },
  { id: "email", name: "Email" },
];

// Value options mapped by field type
export const CONDITION_VALUE_OPTIONS: Record<string, { id: string; name: string }[]> = {
  contacts: [
    { id: "primaryContact", name: "Primary Contact" },
    { id: "secondaryContact", name: "Secondary Contact" },
    { id: "marketingContact", name: "Marketing Contact" },
    { id: "itContact", name: "IT Contact" },
    { id: "accountingContact", name: "Accounting Contact" },
    { id: "socialMediaContact", name: "Social Media Contact" },
    { id: "hrContact", name: "HR Contact" },
    { id: "liaisonContact", name: "Liaison Contact" },
  ],
  leadership: [
    { id: "BOD", name: "BOD" },
    { id: "Regional Council", name: "Regional Council" },
  ],
  "invite-guests": [
    { id: "speakers", name: "Speakers" },
    { id: "guests", name: "Guests" },
  ],
  service: [
    { id: "accounting", name: "Accounting" },
    { id: "investment-banking", name: "Investment Banking" },
    { id: "legal-services", name: "Legal Services" },
  ],
  assoc: [
    { id: "aba", name: "ABA" },
    { id: "iba", name: "IBA" },
    { id: "uia", name: "UIA" },
    { id: "inta", name: "INTA" },
    { id: "ifa", name: "IFA" },
    { id: "atla", name: "ATLA" },
  ],
  region: [
    { id: "north-america", name: "North America" },
    { id: "europe", name: "Europe" },
    { id: "asia-pacific", name: "Asia Pacific" },
    { id: "latin-america", name: "Latin America" },
    { id: "middle-east-africa", name: "Middle East & Africa" },
  ],
  // Default options for other fields (type-to-search fields)
  default: [
    { id: "placeholder-1", name: "Search results will appear here..." },
  ],
};


// Step 3: Action Card Options
export const EMAIL_ACTION_OPTIONS: RadioOption<EmailActionType>[] = [
  { value: "schedule", label: "Schedule Email" },
  { value: "send", label: "Send Email" },
];

export const TIMEZONE_OPTIONS: RadioOption<TimeZoneType>[] = [
  { value: "regional", label: "Regional Time" },
  { value: "est", label: "EST" },
];
